/** Token storage. sessionStorage, so closing the tab ends the session. */
export interface Session {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly expiresAt: number;
}

const KEY = 'gc.session';

export const store = (s: Session): void => sessionStorage.setItem(KEY, JSON.stringify(s));
export const clear = (): void => sessionStorage.removeItem(KEY);

export function load(): Session | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as Session;
    return typeof s.accessToken === 'string' && typeof s.expiresAt === 'number' ? s : null;
  } catch {
    return null; // unparseable storage is the same as signed out
  }
}

/** Refresh a minute early: a token that expires mid-flight fails the request it was for. */
export const isExpired = (s: Session, now = Date.now(), skewMs = 60_000): boolean => s.expiresAt - skewMs <= now;
